<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click.stop="close"><span class="blind">close</span></button>
      <div v-if="detail">
        <div class="title">
          <div class="name">{{ getProductName(detail.serviceName) }}</div>
          <div class="desc">{{ detail.serviceDesc }}</div>
        </div>
        <div class="productDetail">
          <div class="thumb"><img :src="detail.serviceImage"></div>
          <div class="name">{{ detail.vehicleDescription.title }}</div>
          <div class="desc">{{ detail.vehicleDescription.desc }}</div>
        </div>
        <div v-if="cancelPolicy" class="cancelPolicy mt30">
          <p class="label mb5">{{locale.mobility_policy_information_cancel}}</p>
          <ul>
            <li
              v-for="(item, index) in cancelPolicy"
              :key="index">
              {{ item.policy }}
            </li>
          </ul>
        </div>
      </div>
      <div v-else class="noData">{{locale.mobility_product_detail_nodata}}</div>
      <div class="btns mt15">
        <button type="button" class="btn btnWhite toCapitalize" @click.stop="close">{{locale.confirm}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductDetailLayer',
  props: [
    'locale',
    'detail'
  ],
  computed: {
    siteinfo () {
      return this.$store.state.authentication
    },
    cancelPolicy () {
      return this.detail && this.detail.cancelPolicy && this.detail.cancelPolicy.filter(x => x.cancelFee > 0)
    }
  },
  mounted () {
    this.$nextTick(() => {
    })
  },
  data () {
    return {
    }
  },
  methods: {
    getProductName (name) {
      const productName = this.$store.getters['util/getMobilityProductName'](name)
      return this.locale[`mobility_${productName}`]
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  text-align: center;
  font-size: 14px;
  & > .inner {
    max-width: 480px;
    padding: 30px;
  }
}
.title {
  .name {
    font-size: 20px;
  }
  .desc {
    color: $color-grey;
  }
}
.productDetail {
  color: $color-grey;
}
.thumb {
  width: 120px;
  margin: 12px auto;
}
.cancelPolicy {
  text-align: initial;
  li {
    position: relative;
    padding-left: 12px;
    color: $color-grey;
    &:before {
      content: "";
      position: absolute;
      top: 8px;
      left: 0;
      width: 4px;
      height: 4px;
      border-radius: 100%;
      background-color: $color-lgrey;
    }
    & + li {
      margin-top: 5px;
    }
  }
}
</style>
